export default __webpack_public_path__ + "static/bt-5f94e2e10bcb83f125df88b7cd05eddf.svg";